import {GPTPrompt} from "@/model/llmSpecification";

export enum WorkflowLabels {
    SITEBUNNY_CHAT = "sitebunny-chat",
    SITEBUNNY_KEYWORD_CLUSTER = "sitebunny-keyword-cluster",
}

export enum OperatorTypeEnum {
    BRANCH_PYTHON = 'branch_python',
    FAN_IN = 'fan_in',
    FAN_OUT = 'fan_out',
    SEARCH_DATA_SOURCE_RAG = 'search_data_source_rag',
    SEARCH_DATA_SOURCE_FAQ = 'search_data_source_faq',
    SEARCH_DATA_SOURCE_PAGE = 'search_data_source_page',
    LLM = 'llm',
    LANGCHAIN = 'langchain',
    PYTHON = 'python',
    MAP_REFERENCE_DATA_SOURCE = 'map_reference_data_source',
}

export type OperatorType = `${OperatorTypeEnum}`

export interface OperatorBase {
    _id: string
    type: OperatorType
    name?: string
    recursionLimit?: number | null
}

export interface LLMModel {
    vendor: string
    model: string
    contextWindowSize: number
    temperature: number
    maxTokens: number
    [key: string]: any
}

export interface LLMOperator extends OperatorBase{
    type: OperatorTypeEnum.LLM
    model: LLMModel
    stream: boolean
    prompts: GPTPrompt[]
    truncatedOnTokenLimit: object[]
    functionFormat: object[]
    nextOperatorId?: string
}

export interface LangChainOperator extends OperatorBase{
    type: OperatorTypeEnum.LANGCHAIN
    model: LLMModel
    stream: boolean
    prompts: GPTPrompt[]
    truncatedOnTokenLimit: object[]
    tools?: object[] | null
    toolChoice?: string | null
    nextOperatorId?: string
}

export interface SearchRAGOperator extends OperatorBase{
    type: OperatorTypeEnum.SEARCH_DATA_SOURCE_RAG
    mrcAnswerThreshold: number
    mrcThreshold: number
    faqThreshold: number
    size: number
    nextOperatorId?: string
}

export interface BranchPythonOperator extends OperatorBase{
    type: OperatorTypeEnum.BRANCH_PYTHON
    branchMap: {[key: string]: string}
    code: string
    nextOperatorId?: string
}

export interface SearchFAQOperator extends OperatorBase{
    type: OperatorTypeEnum.SEARCH_DATA_SOURCE_FAQ
    threshold: number
    size: number
    nextOperatorId?: string
}

export interface PythonOperator extends OperatorBase{
    type: OperatorTypeEnum.PYTHON
    code: string
    nextOperatorId?: string
}

export interface FanInOperator extends OperatorBase{
    type: OperatorTypeEnum.FAN_IN
    nextOperatorId?: string
}

export interface FanOutOperator extends OperatorBase{
    type: OperatorTypeEnum.FAN_OUT;
    nextOperatorId?: string;
    nextOperatorIds: string[];
}

export type Operator = BranchPythonOperator | FanInOperator | FanOutOperator | SearchRAGOperator | SearchFAQOperator | LLMOperator | LangChainOperator | PythonOperator

export interface InputOperator {
    _id: "input"
    type: "input"
    name: "input"
    parameter: object
    nextOperatorId?: string
}

export interface Workflow {
    _id: string
    description?: string
    firstOperatorId: string
    name?: string
    labels?: string[]
    operators: {[key: string]: Operator}
    defaultParameter?: object
    timeout_sec?: number
    createdAt: string
    updatedAt: string
}

export interface WorkflowCreate {
    name: string
    description?: string
    labels?: string[]
}
